import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { onAuthStateChanged, signOut } from "firebase/auth";
import FirebaseApp, { auth } from "../firebase";
import { findUserRole } from "../utils/auth";
import { GlobalContext } from "./globalContext";

export const GlobalState = (props) => {

    const [loader, setLoader] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [userRole, setUserRole] = useState('');

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) {
                setLoggedIn(false);
                setUserEmail('');
                setUserRole('');
                return;
            }

            setLoader(true);
            try {
                const db = await FirebaseApp();
                const role = await findUserRole(db, user.email);

                if (!role) {
                    await signOut(auth);
                    setLoggedIn(false);
                    setUserEmail('');
                    setUserRole('');
                    toast.error('User with this email does not exist.');
                    return;
                }

                setLoggedIn(true);
                setUserEmail(user.email);
                setUserRole(role);
            } catch (err) {
                console.log('Authentication listener error --->', err);
                toast.error('Authentication error. Please try again.');
                setLoggedIn(false);
                setUserEmail('');
                setUserRole('');
            } finally {
                setLoader(false);
            }
        });

        return () => unsubscribe();
    }, []);

    const value = {
        loader, setLoader,
        loggedIn, setLoggedIn,
        userEmail, setUserEmail,
        userRole, setUserRole
    }

    return (
        <GlobalContext.Provider value={value}>
            {props.children}
        </GlobalContext.Provider>
    )

}
